'use strict';
define([], function () {
    return {
        bind: function () {
            this.navAcceptcookie = window.MS_ROI_COOKIE_BANNER_ENABLE ? document.querySelector('.navigation-cookiebbanner__accept') : document.querySelector('.navigation-cookiebbanner__submit');
            this.navCookieOverlay = window.MS_ROI_COOKIE_BANNER_ENABLE ? document.querySelector('.navigation-cookiebbanner_roioverlay') : false;
            this.navRejectcookiebutton = window.MS_ROI_COOKIE_BANNER_ENABLE ? document.querySelector('.navigation-cookiebbanner__reject') : false;
            this.cookieBanner = window.MS_ROI_COOKIE_BANNER_ENABLE ? document.querySelector('.navigation-cookiebbanner_roi') : document.querySelector('.navigation-cookiebbanner');
            if (this.cookieBanner) {
                this.cookieBanner.style.display = 'flex';
                this.cookieBanner.setAttribute('aria-hidden', false);
            }
            this.acceptCookieBanner = this.acceptCookieBanner.bind(this);
            this.rejectCookieBanner =  this.rejectCookieBanner.bind(this);
            if(this.navRejectcookiebutton && this.navCookieOverlay) {
                this.navRejectcookiebutton.addEventListener('click', this.rejectCookieBanner);
                this.navCookieOverlay.classList.add('active');
                this.navCookieOverlay.addEventListener('focus', function(){
                    document.querySelector('.navigation-cookiebbanner_roititle').focus();
                });
            }
            this.navAcceptcookie.addEventListener('click', this.acceptCookieBanner);
        },
        acceptCookieBanner: function () {
            if (typeof utag !== 'undefined' && typeof utag.gdpr !== 'undefined') { // eslint-disable-line no-undef
                utag.gdpr.setConsentValue(1); // eslint-disable-line no-undef
            }
            this.cookieBanner.style.display = 'none';
            this.cookieBanner.setAttribute('aria-hidden', true);
            if(this.navCookieOverlay){
                this.navCookieOverlay.classList.remove('active');
            }
        },
        rejectCookieBanner: function () {
            if (typeof utag !== 'undefined' && typeof utag.gdpr !== 'undefined') { // eslint-disable-line no-undef
                utag.gdpr.setConsentValue(0); // eslint-disable-line no-undef
            }
            this.cookieBanner.style.display = 'none';
            this.cookieBanner.setAttribute('aria-hidden', true);
            if(this.navCookieOverlay){
                this.navCookieOverlay.classList.remove('active');
            }
        }
    };
});


// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/cookieBanner.js